import { AnyObject, OptionProps } from './custom'

export enum StatementEnrollment {
  electronic = 'ELECTRONIC',
  electronicAndPaper = 'ELECTRONIC_AND_PAPER',
  paper = 'PAPER',
  none = ''
}

export interface EnrollStatementsProps {
  isParentAccount?: boolean
  onSuccessCallback?: (value: string | AnyObject) => void
}
export interface RequestPaperStatementFormData {
  startMonth: OptionProps
  startYear: OptionProps
  endMonth: OptionProps
  endYear: OptionProps
  phoneNumber: string
  email: string
  recipientName: string
  invalidYearAndMonth?: string
  invalidPhoneNumber?: string
  invalidEmail?: string
  invalidRecipientName?: string
  isError?: boolean
  fieldValidation?: {
    phoneNumber: boolean
    email: boolean
    recipientName: boolean
    startMonth: boolean
    endMonth: boolean
    endYear: boolean
    startYear: boolean
  }
}

export interface StatementSummary {
  date: string
  pdfLocation: string
  statementID?: string
}
